import React from 'react';
import styles from '../../styles/AplicacionPagosStyles/AplicacionPagos.module.css';

function SearchSection({ searchTerm, onSearchChange, onSearch, loading }) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className={styles.searchSection}>
      <div className={styles.searchSectionHeader}>
        <div className={styles.searchSectionIcon}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-4h3v4h2v-7.5c0-1.1.9-2 2-2s2 .9 2 2V11h2c1.1 0 2-.9 2-2s-.9-2-2-2H9.5c-.83 0-1.5-.67-1.5-1.5S8.67 4 9.5 4H11c1.1 0 2-.9 2-2s-.9-2-2-2H9.5C7.57 0 6 1.57 6 3.5S7.57 7 9.5 7H11c.28 0 .5.22.5.5s-.22.5-.5.5H9c-2.21 0-4 1.79-4 4V18H4z"/>
          </svg>
        </div>
        <h2 className={styles.searchSectionTitle}>Búsqueda de Estudiante</h2>
      </div>

      <div className={styles.searchInputContainer}>
        <div className={styles.searchIcon}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
        </div>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Buscar Estudiante por Matrícula o Nombre"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
        <button className={styles.searchButton} onClick={onSearch}>
          BUSCAR
        </button>
      </div>
    </div>
  );
}

export default SearchSection;
